import { Observable } from 'rxjs';

import { MeasGroupWithRevision } from '../models/meas-group.model';

export abstract class MeasGroupUsecase {
  abstract get measGroups$(): Observable<MeasGroupWithRevision | undefined>;

  abstract listMeasGroups(): Observable<never>;
}
